import { Injectable } from '@angular/core';
import { AppointmentParking } from '../business-entities/dealer-parking-model';
import { Comments, DemandComments } from '../business-entities/dwo-comments.model';
import { FilesByAppointmentIdResponseModel } from '../business-entities/dwo-documents.model';
import { DwoAppointemntSubCheckListViewModel } from '../business-entities/dwo-sub-check-list-detail-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DwoDocumentsDataService } from '../data-services/dwo-documents-data.serice';
@Injectable({
  providedIn: 'root'
})
export class DwoDocumentsBusinessService {

  checkList: DwoAppointemntSubCheckListViewModel[];

  constructor(private dataService: DwoDocumentsDataService) { }

  getDwoDocumentList(appointmentGUID: string, langCode: string): Promise<GenericResponse<FilesByAppointmentIdResponseModel>> {
    return this.dataService.getDwoDocumentList(appointmentGUID, langCode);
  }

  getDwoDemandComments(appointmentId: number): Promise<GenericResponse<Array<DemandComments>>> {
    return this.dataService.getDwoDemandComments(appointmentId);
  }

  getDwoComments(appointmentId: number): Promise<GenericResponse<Array<Comments>>> {
    return this.dataService.getDwoComments(appointmentId);
  }

  addInternalComment(model:any):Promise<any>{
    return this.dataService.addInternalComment(model)
  }
  DeleteInternalComment(model:any):Promise<any>{
    return this.dataService.DeleteInternalComment(model)
  }
  EditInternalComment(model:any):Promise<any>{
    return this.dataService.EditInternalComment(model)
  }
  EditMediaVisibility(model:any):Promise<any>{
    return this.dataService.EditMediaVisibility(model)
  }

  getAppointmentParkingImage(appointmentId: string): Promise<GenericResponse<AppointmentParking>>{
    return this.dataService. getAppointmentParkingImage(appointmentId)
  }
  DownloadFile(fileName: string): Promise<any> {
    return this.dataService.DownloadFile(fileName);
  }
  deleteDocument(model:any):Promise<any>{
    return this.dataService.deleteDocument(model)
  }
}
